export function createClientConfig<
  TClients extends string,
  TLocales extends string,
>(
  config: Record<
    TClients,
    {
      locales: TLocales[];
      defaultLocale: string;
      hostNames?: string[];
      legacyRedirect?: boolean;
      // used to redirect to another app's QA environment
      qaHostname?: string;
      // Redirect umbrella-host requests (index + deep links) to hostNames[0]
      // in production, like legacyRedirect does, but for subclients that are
      // served from this app (e.g. eon/uk).
      redirectToCanonicalHost?: boolean;
    }
  >
) {
  return config;
}

export type ClientConfigShape = ReturnType<typeof createClientConfig>;
